module.exports = __webpack_public_path__ + "img/mission.29863df2.png";